<template>
  <div
    v-if="subscriptions && $login.can('subscriptions.view')"
    class="subscriptions-list"
  >
    <page-header header="Subscriptions">
      <template slot="suffix">
        <div class="d-inline-flex align-items-center justify-content-center number-indicator">
          {{ subscriptions.length }}
        </div>
      </template>


      <router-link
        v-if="$login.can('subscriptions.create')"
        v-loading="loading"
        :to="{ name: 'subscriptions.create' }"
        class="ml-1 btn btn-primary "
      >
        Create new subscription
      </router-link>
    </page-header>
    <div class="py-3">
      <search v-model="params.search" />

      <vue-good-table
        :rows="subscriptions"
        :columns="tableColumns"
        class="mt-3"
        styleClass="vgt-table"
        :sort-options="{
          enabled: false,
        }"
        @on-row-click="({row}) => onRowClick(row)"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'account'">
            {{ getAccountName(props.row) }}
          </span>
          <span v-else-if="props.column.field == 'status'">
            <span
              class="sub-status"
              :class="{'sub-status--active': props.row.status === 'Active'}"
            >
              <icon
                v-if="props.row.status === 'Active'"
                icon="tick-small"
              />
              <icon
                v-else
                icon="remove-tag"
              />
              {{ props.row.status }}
            </span>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
      </vue-good-table>

      <pagination
        :data="pagination"
        :disabled="loading"
        @change-page="(page) => { params.page = page }"
      />
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axios from '@/axios'
import {createHttpQuery} from '@/helpers'
import Search from '@/components/Search'
import Pagination from '@/components/Pagination'

const defaultPagination = () => {
  return {
    page: 1,
    search: null,
  }
}

export default {
  components: {
    Search,
    Pagination,
    VueGoodTable,
  },

  data () {
    return {
      subscriptions: [],
      pagination: null,
      loading: false,
      params: defaultPagination(),
      tableColumns: [
        {
          label: 'Subscription',
          field: 'name'
        },
        {
          label: 'Account',
          field: 'account'
        },
        {
          label: 'Status',
          field: 'status'
        },
      ]
    }
  },

  metaInfo () {
    return {
      title: 'Subscriptions',
    }
  },

  watch: {
    params: {
      deep: true,
      handler () {
        this.getData()
      },
    },
  },

  created () {
    this.getData()
  },

  methods: {
    async getData () {
      this.loading = true
      const params = createHttpQuery(this.params)
      const {data: subscriptions} = await axios.get('/subscriptions', {params})
      this.pagination = subscriptions.meta
      this.subscriptions = subscriptions.data
      this.loading = false
    },

    onRowClick (sub) {
      this.$router.push({name: 'subscriptions.view', params: {subscriptionId: sub.id}})
    },

    getAccountName ({account}) {
      return account ? account.name : ''
    },
  },
}
</script>

<style lang="scss">
.sub-status {
  color: #fd4431;
  &--active {
    color: #16742e;
  }
}

</style>

